export const SHADOWS = {
	none: 'none',
	xs:   '0 1px 2px rgba(0, 0, 0, 0.05)',                                      // subtle — inputs, small elements
	sm:   '0 1px 4px rgba(0, 0, 0, 0.08)',                                      // cards
	md:   '0 4px 8px rgba(0, 0, 0, 0.10)',                                      // dropdowns, popovers
	lg:   '0 8px 16px rgba(0, 0, 0, 0.12)',                                     // modals, drawers
	xl:   '0 16px 32px rgba(0, 0, 0, 0.14)',                                    // floating panels
}
